/* 
the var's: dateFormat, days and months are declared in the webpage table acoording to the language and date format.
the var's: orderStr, shippStr and etaStr are declared in the order tracking translations.
*/
$(document).ready(function () {
    $('.shipping-update').click(function () {
        document.getElementsByClassName("tmo-progress-bar")[0].scrollIntoView();
    }) 

    // only mobile
    if ($(window).width() < 768) {
        $('.orderTrackingBlock').click(function () {
            $('.orderTrackingWrap').slideToggle();
            $(this).toggleClass("helpCenterMenuActive");
        });
    }

  if($('.thanksOrderBox').length > 0) {

      if ($('.couponLine2').html().trim() == '') {
          $('.couponLineWrap').remove();
          $('.discountLineWrap').remove();
      }

      if ($('.shippingCostLine2').html().trim() == '') {
          $('.shippingCostLineWrap').remove();
      }
      
      if ($('.orderCommentLine2').html().trim() == '') {
          $('.orderCommentLineWrap').remove();
      }

      if ($('.totalTaxLine2').html().trim() == '') {
          $('.totalTaxLineWrap').remove();
      }

      var x = $('.shippingCostLine2').text();
      x = parseInt(x);
      if (x === 0) {
          $('.shippingCostLine2').text("FREE");
      }
  }

  //rebrand progress bar
  if(document.querySelector(".js-bar") !== null) {
      const progressBar = document.querySelector(".js-bar");
      const steps = document.querySelectorAll(".step");
      const actives = document.querySelectorAll(".active-step");
  
      const changeBarDisplay = function () {
          if (window.innerWidth >= 375 && window.innerWidth < 768) {
              progressBar.style.height = `${
                  ((actives.length - 1) / (steps.length - 1)) * 84
              }%`;
          } else {
              progressBar.style.width = `${
                  ((actives.length - 1) / (steps.length - 1)) * 84
              }%`;
          }
      };
  
      const updateProgresseState = function () {
          steps.forEach((step, i) => {
              i < actives.length 
                  ? step.classList.add("active-step")
                  : step.classList.remove("active-step");
          });
  
          changeBarDisplay();
      };
  
      setTimeout(function () {
          updateProgresseState();
      }, 600);
  }
});

$(window).load(function () {
  if (typeof orderStr != 'undefined' && orderStr != '') {
    $('.orderTrackingBanner').hide();
  }

  var oneDay = 24 * 60 * 60 * 1000;
  var today = Date.now();

  if (typeof orderStr != 'undefined') {

      function toDate(dateStr) {
          var dateParts = dateStr.split("/");
          if (dateFormat === 1) {
              return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
          } else if (dateFormat === 2) {
              return new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);
          }
      }

      var orderDate = toDate(orderStr);
      var orderDateNum = Date.parse(orderDate);
      var shippDate = toDate(shippStr);
      var shippDateNum = Date.parse(shippDate);
      var etaDate = toDate(etaStr);
      var etaDateNum = Date.parse(etaDate);

      var totalDays = Math.floor((etaDateNum - orderDateNum) / oneDay);
      var manufacturDays = totalDays / 2;
      var daysOrderPassed = Math.floor((today - orderDateNum) / oneDay);
      var manufacturDaysPercent = daysOrderPassed / manufacturDays;
      var totalShipping = Math.floor((etaDateNum - shippDateNum) / oneDay);
      var daysSippPassed = Math.floor((today - shippDateNum) / oneDay);
      var shippDaysPercent = daysSippPassed / totalShipping;

      var daysShippRemined = Math.ceil((etaDateNum - today) / oneDay);

      var dayName = days[etaDate.getDay()];
      var monthName = months[etaDate.getMonth()];
      var dateNumber = etaDate.getDate();

      $('#etaDay').html(dayName);
      $('#etaMonth').html(monthName);
      $('#etaDate').html(dateNumber);

      if(!document.getElementById('tmo-wrapper')) {

          var barElem = $('.progress-bar').find('li').get();
          var stepsElem = $('.progress-text').find('li').get();
          // var barHeight = $('.progress-bar').outerHeight();
          var nm = 0;
          if ($('.ot-shipped').length > 0) {
              nm = 4;
              for (var k = 0; k < nm; k++) {
                  $(barElem[k + 1]).addClass('complate');
              }
  
              $(stepsElem[k]).addClass('text-complate');
          }
  
          (function animateBar() {
              nm++;
              // var thisPos = $(barElem[nm]).position().top;
              var thisHeight = $(barElem[nm]).outerHeight();
              // var goToHeight = barHeight - thisPos - thisHeight;
              var goToHeight =  thisHeight;
              // $('#progress-bg').css('height', $('.progress-bar').outerHeight() - $(barElem[nm]).position().top);
              $('#progress-bg').css('height', $(barElem[nm]).position().top);
              setTimeout(function () {
                  $(barElem[nm]).addClass('complate');
  
                  var dataStep = $(barElem[nm]).attr('data-step');
  
                  if ($(barElem[nm]).hasClass('current') && dataStep == 'manufacturing' && daysOrderPassed > 0) {
                      setTimeout(function () {
                          if (manufacturDaysPercent < 0.85) {
                              goToHeight = goToHeight + thisHeight * manufacturDaysPercent;
                          } else {
                              goToHeight = goToHeight + thisHeight * .85;
                          }
                          //$('#progress-bg').css('height', $('.progress-bar').outerHeight() - $(barElem[nm]).position().top);
                            $('#progress-bg').css('height', $(barElem[nm]).position().top);
                          $(stepsElem[nm - 1]).addClass('text-complate');
                      }, 200);
                      return;
                  } else if ($(barElem[nm]).hasClass('current') && dataStep == 'shipped' && daysSippPassed > 0) {
                      setTimeout(function () {
                          if (shippDaysPercent < 1 && shippDaysPercent > 0) {
                              goToHeight = goToHeight + (thisHeight * shippDaysPercent) * 2;
                              //$('#progress-bg').css('height', $('.progress-bar').outerHeight() - $(barElem[nm]).position().top);
                                $('#progress-bg').css('height', $(barElem[nm]).position().top);
                              $(stepsElem[nm - 1]).addClass('text-complate');
                              if (shippDaysPercent > 0.2 && shippDaysPercent < 0.9) {
                                  $('.shipping-point').css('display', 'block')
                              }
                          } else if (shippDaysPercent >= 1) {
                              goToHeight = goToHeight + thisHeight * 2;
                              //$('#progress-bg').css('height', $('.progress-bar').outerHeight() - $(barElem[nm]).position().top);
                                $('#progress-bg').css('height', $(barElem[nm]).position().top);
                              $(stepsElem[nm - 1]).addClass('text-complate');
                          }
                      }, 200);
                      return;
                  } else if ($(barElem[nm]).hasClass('current')) {
                      $(stepsElem[nm - 1]).addClass('text-complate');
                      return;
                  } else {
                      animateBar()
                  }
              }, 500);
  
              // only desktop
              if ($(window).width() >= 768) {
  
                  var widthElem = 0;
                  $('.progress-bar li').each(function (index, elem) { 
  
                      // count width until current status
                      if ($(elem).hasClass('complate') && !$(elem).hasClass('current')) {
                        widthElem = $(elem).width() + widthElem;
                      }
  
                      $('#progress-bg').css('width', widthElem + 'px');
                      $('#progress-bg').css('height', '2px');
                    });
              }
          })();
      }
      var journeyBtn = $('.journey-txt').find(' > span');
      $(journeyBtn).on('click', function () {

        $("#progress-bg").css('bottom', '-60px');
        $('#progress-bg').css('height', '240px');          
        
        if ($('.progress-box').hasClass('journey-open')) {
              $('.progress-box').animate({ 'height': '185px' }).removeClass('journey-open');
          } else {
              $('.progress-box').animate({ 'height': '360px' }).addClass('journey-open');
          }
      }); 

      $('.ot-tooltip-btn').on('click', function () {
          $('.ot-tooltip-msg').toggle();
      });
      $('body').on('click', function () {
          $('.ot-tooltip-msg').hide();
      });

      $('.ot-tooltip').click(function (e) {
          e.stopPropagation();
      });


  }

})